import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from "../../appTheme";

export const addEditBuyXgetYDiscountStyle = StyleSheet.create({
    container: {
        flex: 1
    },
    loader: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center'
    },
    containerView: {
        flex: 1,
        backgroundColor: appColors.lightBackgroundColor
    },
    buttonView: {
        flexDirection: 'row',
        alignSelf: 'flex-end',
        marginVertical: 10
    },
    titleStyle: {
        color: appColors.primary,
        fontFamily: appFonts.bold
    },
    buttonStyle: {
        borderColor: appColors.primary,
        borderWidth: 1,
        borderRadius: 10,
        paddingHorizontal: 15
    },
    saveBtnStyle: {
        marginHorizontal: 15,
        right: 5,
        backgroundColor: appColors.primary,
        borderWidth: 1,
        borderColor: "transparent",
        paddingVertical: 2,
        borderRadius: 10
    },
    buttonContainer: {
        paddingHorizontal: 10
    },
    saveBtnTextStyle: {
        color: appColors.light,
        fontSize: fontSize.smallerFontSize,
        fontFamily: appFonts.bold,
        marginHorizontal: 7
    },
    cardContainer: {
        borderRadius: 10,
        marginBottom: 10,
        flex: 1,
        marginTop: 0,
        elevation: 0,
        borderColor: 'transparent',
        paddingHorizontal: 0
    },
    labelStyle: {
        fontSize: fontSize.smallerFontSize,
        fontFamily: appFonts.medium,
        color: appColors.labelColor
    },
    inputStyle: {
        fontSize: fontSize.smallerFontSize,
        color: appColors.lightDark,
        fontFamily: appFonts.medium
    },
    inputContainerStyle: {
        borderColor: appColors.borderColor,
        height: 45
    },
    errorStyle: {
        color: appColors.red,
        marginLeft: -1,
        fontSize: fontSize?.errorFontSize
    },
    inputView: {
        flex: 0.5,
    },
    textStyle: {
        marginTop: 10
    },
    cardRestriction: {
        borderRadius: 10,
        elevation: 0,
        borderColor: 'transparent',
        paddingHorizontal: 0,
    },
    descriptionTxtStyle: {
        color: appColors.labelColor,
        fontSize: fontSize?.smallerFontSize,
        fontFamily: appFonts?.medium,
        paddingHorizontal: 10,
        marginBottom: 3,
    },
    CustomerBuyView: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        flex: 1
    },
    addProductBtnStyle: {
        borderColor: appColors.borderColor,
        borderWidth: 1,
        borderRadius: 7,
        paddingHorizontal: 10,
        paddingVertical: 2
    },
    innerCardStyle: {
        borderRadius: 5,
        borderWidth: 1,
        elevation: 0,
        paddingBottom: 0
    },
    deleteIconStyle: {
        justifyContent: 'center'
    },
    customerGetsView: {
        marginLeft: -5,
        marginTop: 10,
        flex: 1,
        flexDirection: 'row'
    }
})